import React from 'react';
import { motion } from 'framer-motion';
export function CauseSection() {
  return <section className="bg-white py-20 px-4 border-t border-soft-gray" data-id="element-39">
      <div className="max-w-4xl mx-auto" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-42">
            Por qué tu bebé no duerme aunque parezca que hacés todo bien
          </h2>
          <p className="text-xl text-navy/80 max-w-2xl mx-auto" data-id="element-43">
            El problema no es que tu bebé sea "malo durmiendo". Los bebés no son
            buenos ni malos durmiendo. Son bebés que aprendieron ciertos hábitos
            de sueño.{' '}
            <strong className="text-navy" data-id="element-44">
              Y los hábitos se pueden cambiar.
            </strong>
          </p>
        </motion.div>

        <h3 className="text-2xl font-bold text-center text-navy mb-10" data-id="element-45">
          LAS 3 RAZONES MÁS COMUNES POR LAS QUE NADA FUNCIONA
        </h3>

        <div className="space-y-8" data-id="element-46">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-warm-white p-8 rounded-2xl shadow-sm border border-soft-gray" data-id="element-47">
            <h4 className="text-xl font-bold text-navy mb-4 flex items-center gap-3" data-id="element-48">
              <span className="bg-sky text-white w-8 h-8 rounded-full flex items-center justify-center text-sm" data-id="element-49">
                1
              </span>
              RAZÓN 1: El momento en que intentás dormirlo no es el correcto.
            </h4>
            <p className="text-navy/80 text-lg leading-relaxed" data-id="element-50">
              Existe una ventana de tiempo exacta para cada bebé según su edad.
              Si llegás antes o después de esa ventana, el proceso es mucho más
              difícil. Y la mayoría de los padres no sabe que existe esa ventana
              ni cómo encontrarla.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-warm-white p-8 rounded-2xl shadow-sm border border-soft-gray" data-id="element-51">
            <h4 className="text-xl font-bold text-navy mb-4 flex items-center gap-3" data-id="element-52">
              <span className="bg-sky text-white w-8 h-8 rounded-full flex items-center justify-center text-sm" data-id="element-53">
                2
              </span>
              RAZÓN 2: Tu bebé aprendió a dormirse con una condición que vos
              proveés.
            </h4>
            <p className="text-navy/80 text-lg leading-relaxed" data-id="element-54">
              Tus brazos. El pecho. El movimiento. El chupete. Cuando se
              despierta entre ciclos de sueño, busca esa condición. No la
              encuentra. Llora. No es manipulación. Es neurología. Y se puede
              cambiar.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-warm-white p-8 rounded-2xl shadow-sm border border-soft-gray" data-id="element-55">
            <h4 className="text-xl font-bold text-navy mb-4 flex items-center gap-3" data-id="element-56">
              <span className="bg-sky text-white w-8 h-8 rounded-full flex items-center justify-center text-sm" data-id="element-57">
                3
              </span>
              RAZÓN 3: No hay una rutina consistente que le diga al cerebro que
              el sueño está llegando.
            </h4>
            <p className="text-navy/80 text-lg leading-relaxed" data-id="element-58">
              El cerebro del bebé aprende por repetición. Cuando hay una
              secuencia clara y consistente, el cerebro empieza a prepararse
              para dormir antes de llegar a la cuna. Cuando no hay secuencia, el
              cerebro no anticipa y el dormido es más difícil.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-16" data-id="element-59">
          <p className="text-2xl font-bold text-navy mb-2" data-id="element-60">
            Estas tres cosas tienen solución concreta.
          </p>
          <p className="text-xl text-sky font-semibold" data-id="element-61">
            Y el Método Noches de Paz™ fue diseñado específicamente para
            resolverlas.
          </p>
        </motion.div>
      </div>
    </section>;
}